import Layout from '@/layout'
// import routerView from '@/layout/routerView.vue'
const sysManageRouter = {
  path: '/form',
  component: Layout,
  redirect: '/form/index',
  name: 'form',
  permissionCode: '26222',
  meta: {
    title: '表单管理',
    icon: 'nav-form'
  },
  children: [
    {
      path: 'index',
      component: () => import('@/views/form/page/index.vue'),
      name: 'formIndex',
      permissionCode: '43508',
      meta: { title: '表单设计' }
    },
    // {
    //   path: 'template',
    //   component: () => import('@/views/form/page/template.vue'),
    //   name: 'formTemplate',
    //   meta: { title: '表单模板' }
    // },
    {
      path: 'design',
      hidden: true,
      component: () => import('@/views/form/page/design/index.vue'),
      name: 'formDesign',
      meta: { title: '自定义表单', noNavBar: true, hidePadding: true }
    }
  ]
}
export default sysManageRouter
